// Body.js
import React from 'react';
import PropsComponent from "../../props-component/PropsComponent.js";
import "../body.css";

function Body() {
  return (
    <div>
    

      <PropsComponent
      inerdiv1="iPhone15Pro inerdiv1"
        h1="iPhone 15 Pro"
        h2="Titanium. So strong. So light. So Pro."
        link1="#"
        link2="#"
      />
      
    </div>
  );
}

export default Body;
